export default "__VITE_ASSET__9f99bdf2__"